"use client";

import { useMultiLanguages } from "@/app/utils/multiLanguage/MultiLanguageContext";
import dynamic from "next/dynamic";
import { useInView } from "react-intersection-observer";

const Home = dynamic(() => import("@/app/Components/Pages/Home"), {
  ssr: false,
});

export default function HomeWrapper() {
  const { locale } = useMultiLanguages();

  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "200px",
  });

  return (
    <div ref={ref}>
      {inView ? (
        <Home />
      ) : (
        <p className="flex text-center text-gray-500 h-screen justify-center items-center">
          {locale === "id"
            ? "Memuat konten beranda..."
            : "Loading home content..."}
        </p>
      )}
    </div>
  );
}
